/* eslint-disable @typescript-eslint/no-unused-vars */
import Axios from 'axios';

const token = process.env.REACT_APP_WRAPPER_TOKEN;

export const api = Axios.create({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  baseURL: 'https://emjp73uf09.execute-api.us-east-2.amazonaws.com',
  headers: {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  },
  withCredentials: false
});